import React from 'react'
import { itemImages } from './PdaPhotos'

/**
 * A tappable list of inventory items — the putaway worklist, and the contents
 * of a location in Look Up. One implementation so the two always agree on what
 * an item row looks like and which fields it shows.
 */
export default function ItemRows({ items, emptyText, onPick, showLocation = false }) {
    if (!items.length) return <div className="pda-empty">{emptyText}</div>

    return (
        <ul className="pda-list">
            {items.map((item) => (
                <li key={item.item_id}>
                    <button className="pda-row" onClick={() => onPick(item)}>
                        {itemImages(item)[0] && <img src={itemImages(item)[0]} alt="" loading="lazy" />}
                        <span className="pda-row-main">
                            <span className="pda-held-title">{item.title}</span>
                            <span className="pda-code">
                                {item.item_id}
                                {showLocation && item.current_position ? ` · slot ${item.current_position}` : ''}
                            </span>
                        </span>
                    </button>
                </li>
            ))}
        </ul>
    )
}
